import Utils from "../misc/Utils";

class Modals {
    static showModalTemplate(modalId, onRenderCallback) {
        let $template = jQuery('[data-modal-id='+ modalId +']');
        let $modal = jQuery($template.html());
        let $tmp = jQuery('<div></div>');

        $tmp.html($modal);
        jQuery(document.body).append($tmp);
        Utils.showBodyOverlay()
        $modal.show().addClass('modal-show');
        if(typeof onRenderCallback !== 'undefined'){
            onRenderCallback($tmp);
        }
        return false;
    };
    static hideModalTemplate(trigger){
        let $modal = jQuery(trigger).parents('.modal-show');
        $modal.parent().remove();
        Utils.hideBodyOverlay();
    };

    static initEvents() {
        jQuery(document.body)
            .on('click', '[data-toggle-login-modal]', function (evt){
                evt.preventDefault();
                Modals.showModalTemplate('login-modal', function ($modal) {
                    $modal.on('click', '[data-close-modal]', function () {
                        Utils.animateDockIcons(jQuery('.mobile-dock-nav').find('.was-active'));
                    });
                });
            })
            .on('click', '[data-toggle-modal]', function (evt){
                evt.preventDefault();
                Modals.showModalTemplate(jQuery(this).attr('data-toggle-modal'));
            })
            .on('click', '[data-close-modal]', function (){
                Modals.hideModalTemplate(jQuery(this));
            });
    }
    static initModule() {
        Modals.initEvents();
    }
}

export default Modals;